export enum WindowMode {
    POPUP = 'POPUP',
    REDIRECT = 'REDIRECT',
}
